import axios, { type AxiosError, type AxiosInstance } from 'axios';

import { API_BASE_URL } from '@constants/config';

import { type ApiError } from './types';

const httpClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60_000,
  headers: { 'Content-Type': 'application/json' },
});

httpClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ detail?: string }>) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail || error.message;
    const normalized: ApiError = new Error(detail);
    normalized.status = status;
    normalized.payload = error.response?.data;
    return Promise.reject(normalized);
  },
);

export default httpClient;
